export default __webpack_public_path__ + "static/media/devguide03.bd3cb154.md";